module.exports = __webpack_public_path__ + "static/TMN_standardy-34614cc3d86cea9ace8f6858aaa82261.jpg";